import React, { useEffect, useState } from "react";
import bgImg from "../../assets/bg_img.jpg";
import reject from "../../assets/reject.svg";
import gif from "../../assets/cardGif.gif";
import { Row, Col, Button, Typography, message } from "antd";
import arrowleft from "../../assets/back-arrow.svg";
import { useNavigate } from "react-router-dom";
import { useAllProduct } from "../../components/api-context/commonApiContext";
import Config from "../../config/Config";

const { Title, Text } = Typography;

const KycStatus = () => {
  const { merchantInfo } = useAllProduct();
  const [kycStatus, setKycStatus] = useState("initiated");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isInitComplete, setInitComplete] = useState(false);

  // ✅ Step 1: Call /get-kyc-data once when screen opens
  useEffect(() => {
    if (!merchantInfo?.merchant_id || !merchantInfo?.payment_id) return;

    const updateKycData = async () => {
      try {
        const res = await fetch(`${Config.node_api_endpoint}/get-kyc-data`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({
            merchant_id: merchantInfo.merchant_id,
            payment_id: merchantInfo.payment_id,
          }),
        });

        const data = await res.json();
        console.log("✅ get-kyc-data response:", data);

        // ✅ After KYC processing begins — enable next phase
        setInitComplete(true);
      } catch (err) {
        console.error(" Error calling /get-kyc-data:", err);
      }
    };

    updateKycData();
  }, [merchantInfo]);

  // useEffect(() => {
  //   if (!isInitComplete || !merchantInfo?.payment_id) return;

  //   let intervalId;
  //   let attempts = 0;
  //   const maxAttempts = 40;

  //   const pollStatus = async () => {
  //     try {
  //       const res = await fetch(`${Config.node_api_endpoint}/get-user-status`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-API-Key": process.env.REACT_APP_API_KEY,
  //         },
  //         body: JSON.stringify({ payment_id: merchantInfo.payment_id }),
  //       });

  //       const data = await res.json();
  //       if (!data.success) return;

  //       const status = data.data.kyc_status;
  //       setKycStatus(status);

  //       console.log("🔄 Polled KYC Status:", status);

  //       if (status === "completed") {
  //         clearInterval(intervalId);
  //         setLoading(false);
  //         message.success("✅ KYC Completed!");
  //         navigate("/load-money");
  //       }

  //       if (status === "rejected") {
  //         clearInterval(intervalId);
  //         setLoading(false);
  //       }

  //       attempts++;
  //       if (attempts >= maxAttempts) {
  //         clearInterval(intervalId);
  //         setLoading(false);
  //         message.warning("⏳ KYC taking too long. Try again later.");
  //       }
  //     } catch (err) {
  //       console.error("⛔ Polling error:", err);
  //     }
  //   };

  //   intervalId = setInterval(pollStatus, 3000);

  //   return () => clearInterval(intervalId);
  // }, [isInitComplete, merchantInfo?.payment_id, navigate]);

  useEffect(() => {
    const paymentId = merchantInfo?.payment_id;
    if (!isInitComplete || !paymentId) return;

    const checkKycStatus = async () => {
      try {
        setLoading(true);

        const res = await fetch(`${Config.node_api_endpoint}/get-user-status`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({ payment_id: paymentId }),
        });

        const data = await res.json();
        if (!data.success) {
          setLoading(false);
          message.error("Unable to fetch KYC status. Please try again.");
          return;
        }

        const status = data?.data?.kyc_status;
        setKycStatus(status);
        console.log("KYC Status:", status);

        if (status === "completed") {
          setLoading(false);
          message.success("✅ KYC Completed!");
          navigate("/load-money");
        } else if (status === "rejected") {
          setLoading(false);
          message.warning("❌ KYC Rejected. Please re-submit.");
        } else {
          setLoading(false);
          message.info("KYC is still processing. Please check again later.");
        }
      } catch (err) {
        console.error("⛔ KYC status error:", err);
        setLoading(false);
        message.error("Network error. Please try again.");
      }
    };

    checkKycStatus();
  }, [isInitComplete, merchantInfo?.payment_id, navigate]);

  return (
    <div
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        height: "100vh",
        padding: "50px 20px",
      }}
    >
      <Row justify="center" style={{ maxWidth: 420, margin: "0 auto" }}>
        <Col span={24}>
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 20 }}
          >
            <img
              src={arrowleft}
              alt="Back"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/sign-up")}
            />
            <Title
              level={4}
              style={{
                color: "#333",
                margin: 0,
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              KYC Verification
            </Title>
          </div>

          <Text style={{ color: "#333", fontSize: "18px", fontWeight: 700 }}>
            Welcome to <span style={{ color: "#2348AB" }}>Khazana Card</span>
          </Text>

          {loading ? (
            <div style={{ textAlign: "center", marginTop: 60 }}>
              <img src={gif} alt="Loading" width={160} />
              <Text style={{ color: "#555", display: "block", marginTop: 10 }}>
                Verifying your identity…
              </Text>
            </div>
          ) : (
            kycStatus !== "completed" && (
              <>
                <Title
                  level={5}
                  style={{ color: "#333333", marginTop: 20, marginBottom: 10 }}
                >
                  Your KYC verification has been rejected.
                </Title>
                <Text
                  style={{
                    color: "#9E9EA0",
                    display: "block",
                    marginBottom: 30,
                  }}
                >
                  Please re-submit your details.
                </Text>
                <div style={{ textAlign: "center", marginTop: 40 }}>
                  <img src={reject} alt="Rejected" width={120} />
                </div>
                <div className="d-flex justify-content-center w-100 mt-4">
                  <Button
                    type="primary"
                    className="w-100"
                    size="large"
                    style={{
                      backgroundColor: "#2348AB",
                      borderRadius: 10,
                      border: "none",
                      boxShadow: "0 0 15px rgba(35,72,171,0.6)",
                      fontWeight: 600,
                    }}
                    onClick={() => navigate("/kyc")}
                  >
                    Re-try KYC
                  </Button>
                </div>
              </>
            )
          )}
        </Col>
      </Row>
    </div>
  );
};

export default KycStatus;
